import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alert } from 'antd';
import { loadFeatureSettings } from '../../../../global/featureFlags';

// Names the user's own departments that ARM is running. `arm` comes from the
// features payload: running is false when ARM is off or paused for the org, and
// department_ids is 'all' or the departments ARM publishes. A failed read shows
// nothing.
export const armDepartmentNames = (arm, departments) => {
  if (!arm?.running) return [];

  const scoped = arm.department_ids === 'all'
    ? departments
    : departments.filter((department) => (arm.department_ids || []).map(Number).includes(Number(department.id)));
  return scoped.map((department) => department.name);
};

const ArmRunningBanner = ({ departments }) => {
  const [arm, setArm] = useState(null);

  useEffect(() => {
    let isMounted = true;
    loadFeatureSettings('arm').then((settings) => {
      if (isMounted) setArm(settings);
    }).catch(() => {});

    return () => {
      isMounted = false;
    };
  }, []);

  const names = armDepartmentNames(arm, departments || []);
  if (names.length === 0) return null;

  let message;
  if (arm.department_ids === 'all') {
    message = 'Agentic Referral Management is being run on all departments';
  } else if (names.length === 1) {
    message = `This department is being run on Agentic Referral Management: ${names[0]}`;
  } else {
    message = `These departments are being run on Agentic Referral Management: ${names.join(', ')}`;
  }

  return <Alert data-testid="arm-running-banner" type="warning" banner showIcon={false} message={message} />;
};

ArmRunningBanner.propTypes = {
  departments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
  })),
};

ArmRunningBanner.defaultProps = {
  departments: [],
};

export default connect((state) => ({ departments: state.auth.departments }))(ArmRunningBanner);
